import moment from 'moment'
import type Moment from 'moment'
import {
  DATE_CHART_FORMAT,
  DATE_DISPLAY_FORMAT,
  DATETIME_FORMAT
} from '../constants'

type Mode = 'day'|'week'|'month'

export const getDuration = (start, end) => end.toDate().getTime() - start.toDate().getTime()
export const offset = moment().utcOffset()

export const formatTimePeriod = (milli, intl)=>{
  const format = intl.formatMessage
  const formatNumber = (n)=>(intl.formatNumber(Math.round(n)))

  if(milli < 60*1000){
    return `${formatNumber(milli/1000)} ${format({id:'second'})}`
  }else if(milli < 60*60*1000){
    return `${formatNumber(milli/(60*1000))} ${format({id:'minute'})}`
  }else{
    return `${formatNumber(milli/(60*60*1000))} ${format({id:'hour'})}`
  }
}

export const formatInLocalTimeZone = (date: Moment, formatStr: string)=> (date?date.utcOffset(offset).format(formatStr):'')
export const formatDateInReport = (date: Moment)=>{
  return formatInLocalTimeZone(date, 'll')
}

export const formatMonthInReport = (date: Moment)=>{
  return formatInLocalTimeZone(date, 'MMM YYYY')
}

export const formatDateRange = (startDate: Moment, endDate: Moment)=>
  `(${formatDateInReport(startDate)} -- ${formatDateInReport(endDate)})`

export const formatMonthRange = (startDate: Moment, endDate: Moment)=>
  `(${formatMonthInReport(startDate)} -- ${formatMonthInReport(endDate)})`

export const format = (date: ?Moment):?string => {
  return date ? (date.utc().format("YYYY-MM-DDTHH:mm:ss") + 'Z') : null
}
export const parse = (str: string) => (str?moment.utc(str, "YYYY-MM-DDTHH:mm:ss"):str)
export const convertToDisplayFormat = (str: string, format:string) => (str?formatInLocalTimeZone(parse(str), format?format:DATETIME_FORMAT):'')
export const dateRangeToLabels = (startDate: Moment, endDate: Moment, mode:Mode = 'day', dayFormat: string = DATE_CHART_FORMAT, monthFormat: string = 'YYYY-MM')=> {
  const labels = {}
  const itr = moment.twix(startDate, endDate).iterate(mode + 's')
  while (itr.hasNext()) {
    if (mode === 'day') {
      const date = itr.next()
      const key = formatInLocalTimeZone(date, dayFormat)
      labels[key] = [formatInLocalTimeZone(date, 'ddd'), formatInLocalTimeZone(date, 'll')]
    } else if (mode === 'week') {
      const weekStart = itr.next()
      const weekEnd = moment(weekStart).add(6, 'days')
      const key = formatInLocalTimeZone(weekStart, dayFormat)
      const weekDayFormat = 'DD MMM'
      labels[key] = [formatInLocalTimeZone(weekStart, weekDayFormat) + ' - ' + formatInLocalTimeZone(weekEnd, weekDayFormat), formatInLocalTimeZone(weekStart, 'YYYY')]
    } else if (mode === 'month') {
      const monthStart = itr.next()
      const key = formatInLocalTimeZone(monthStart, dayFormat)
      labels[key] = [formatInLocalTimeZone(monthStart, 'MMM'), formatInLocalTimeZone(monthStart, 'YYYY')]
    }

  }
  return labels
}

export const dateRangeChartData = (startDate: Moment, endDate:Moment, mode:Mode = 'day', dataMap:{[key:string]:Array<Object>}, dateTimeFieldName:string)=> {

  const chartDataMap = {}

  const labelsMap = dateRangeToLabels(startDate, endDate, mode)
  const keys = Object.keys(labelsMap).sort()

  for (var key in dataMap) {
    const list = dataMap[key] || []
    let buckets = {}
    keys.forEach((l) => {
      buckets[l] = 0
    })

    list.forEach((g)=> {
      buckets[parse(g[dateTimeFieldName]).startOf(mode).format(DATE_CHART_FORMAT)] += 1
    })

    chartDataMap[key] = keys.map((it)=>buckets[it]) || []
  }


  return {
    labels: keys.map((k)=>labelsMap[k]),
    chartDataMap
  }

}

export default {format, parse, formatInLocalTimeZone}



// WEBPACK FOOTER //
// ./src/util/DateUtil.js